<template>
  <!-- 以前的机台正在生产工单信息的界面，现在展示为弹框 -->
  <div class="card">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" :stretch="true">
      <el-tab-pane label="工单" name="workOrder" class="workOrderDiv">
        <ul style="margin:5px 0 50px 0">
          <li :style="listyle" class="js">进度: {{(workOrder.progress * 100).toFixed(2)}}%</li>
        </ul>
        <div class="orderItemBody">
          <p>工单编号</p>
          <p>{{workOrder.number}}</p>
          <p>需求生产米数</p>
          <p>{{workOrder.outputQuantity/100 + "M"}}</p>
          <p>落布米数</p>
          <p>{{workOrder.dropMeter/100 + "M"}}</p>
          <p>门幅数量</p>
          <p>{{workOrder.doorWidth}}</p>
          <p>幅宽</p>
          <p>{{workOrder.widthCloth}}</p>
          <p>车速</p>
          <p>{{workOrder.speed+ "转/分钟"}}</p>
          <p>生产时间</p>
          <p>{{workOrder.updateTime}}</p>
          <p>创建时间</p>
          <p>{{workOrder.createTime}}</p>
        </div>
      </el-tab-pane>

      <el-tab-pane label="生产单" name="process" class="processDiv">
        <define-input label="客户" v-model="productTask.customer" style="width: 350px;margin-left:-60px" disabled></define-input>
        <define-input label="订单日期" v-model="productTask.orderDate" style="width: 350px;margin-left:-30px" disabled></define-input>
        <define-input label="坯布名称" v-model="productTask.product" style="width: 350px;margin-left:-30px" disabled></define-input>
        <define-input label="订单数量" v-model="productTask.outputQuantityTotal" style="width: 350px;margin-left:-30px" disabled></define-input>
        <define-input label="工艺组织" v-model="productTask.processOrganization" style="width: 350px;margin: 3px 0 3px -30px" disabled></define-input>
        <define-input label="针织密度" v-model="productTask.density" style="width: 350px;margin: 3px 0 3px -30px" disabled></define-input>
        <define-input label="创建者" v-model="productTask.user.username" style="width: 350px;margin: 3px 0 3px -30px" disabled></define-input>
        <define-input label="订单补充说明" v-model="productTask.supplementaryNote" style="width: 995px;margin: 3px 0 10px -60px" disabled></define-input>
        <el-card>
          <define-table :data="productTask.processSheets" :height="`${productTask.processSheets.length * 55 + 70}px`" class="table1" style="margin-left:3px"
                        :haveIndex="false" :havePage="false" :fit="false">
            <define-column field="combKnot" label="梳节" width="130px"></define-column>
            <define-column columnType="expand">
              <template v-slot="{ data }">
                <default-input label="垫纱记录" v-model="data.row.yarnNote" style="margin: -40px 0 5px 83px;width:1121px"></default-input><br>
                <default-input label="穿纱方式" v-model="data.row.threadingMethod" style="width:1121px;margin: 0 0 0 83px"></default-input>
              </template>
            </define-column>
            <define-column field="materialFormat" label="原料规格" width="130px"></define-column>
            <define-column field="materialsBatchNumber" label="原料批号" width="130px"></define-column>
            <define-column field="coil" label="线圈长度" width="130px"></define-column>
            <define-column field="hairline" label="头纹" width="130px"></define-column>
            <define-column field="panHead" label="盘头个数" width="130px"></define-column>
            <define-column field="yarnFeed" label="送纱量" width="130px"></define-column>
          </define-table>
        <el-input type="textarea" :rows="2" placeholder="工艺补充说明" v-model="productTask.processSheetSupplementaryNote"/>
        </el-card>
        <el-card>
      <div style="height:200px">
        <define-table :data="productTask.productOrderItems" :height="`${productTask.productOrderItems.length * 55 + 55}px`" style="margin-left: 0px" :havePage="false">
          <define-column field="machine.number" label="机台编号"></define-column>
          <define-column field="machine.workshop" label="所在车间"></define-column>
          <define-column field="speed" label="车速"></define-column>
          <define-column field="dropMeter" label="落布米数"></define-column>
          <define-column field="doorWidth" label="门幅数量"></define-column>
          <define-column field="widthCloth" label="幅宽"></define-column>
          <define-column v-slot="{ data }" label="工单状态">
            <el-tag v-if="data.row.productStateEnum  == 'READY_TO_PRODUCT'" type="info">待生产</el-tag>
            <el-tag v-if="data.row.productStateEnum  == 'IN_PRODUCT'">生产中</el-tag>
            <el-tag v-if="data.row.productStateEnum  == 'END_PRODUCT'" type="success">生产完成</el-tag>
          </define-column>
          <define-column label="进度" v-slot=" {data }">
            <el-tag type="warning" size="big">{{(data.row.progress*100).toFixed(2)}}%</el-tag>
          </define-column>
          <define-column label="操作" v-slot="{ data }">
            <el-tooltip effect="dark" content="时间线" placement="bottom" :enterable="false">
              <i class="iconfont icontimeline1" id="timeline" @click="toTimeLine(data.row.id)"></i>
            </el-tooltip>
          </define-column>
        </define-table>
      </div>
    </el-card>
    </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as api from '@/api/factory/machine/order'
export default {
  name: 'MachineOrder',
  data () {
    return {
      activeName: 'workOrder',
      processId: '',
      productTask: {
        user: {
          username: ''
        },
        processSheets: [],
        productOrderItems: []
      },
      workOrder: {
        progress: 0
      },
      listyle: {
        '--process': '0%'
      }
    }
  },

  methods: {
    toTimeLine (id) {
      this.$router.push(`/machine/machinePreview/machineTimeLine/${id}`)
    },
    getWorkOrder(id) {
      var params = { id: id }
      api.getWorkOrder(params).then(res => {
        this.workOrder = res.data
        this.workOrder.createTime = this.$filterTime(this.workOrder.createTime)
        this.workOrder.updateTime = this.$filterTime(this.workOrder.createTime)
        console.log('workOrder', this.workOrder)
        this.listyle['--process'] = res.data.progress * 100 + '%'
      }, rej => {
        this.$Message.error('机台工单获取失败')
      })
    },
    getProcess(id) {
      var params = { productId: id }
      api.getProcess(params).then(res => {
        this.productTask = res.data
        this.productTask.outputQuantityTotal /= 100
        this.productTask.dropMeter /= 100
        this.productTask.productOrderItems.forEach(item => {
          item.outputQuantity /= 100
        })
      }, rej => {
        this.$Message.error('机台生产单获取失败')
      })
    },
    getfetch() {
      var params = { machineId: this.$route.params.id }
      api.getfetch(params).then(res => {
        this.processId = res.data.productOrderId
        this.getProcess(res.data.productOrderId)
        this.getWorkOrder(res.data.productOrderItemId)
      }, rej => {
        this.$Message.error('机台工单获取失败')
      })
    },
    handleClick(tab, event) {}
  },

  mounted () {
    this.getfetch()
  }
}
</script>

<style scoped>
.orderItemBody {
  display: grid;
  grid-template-columns: 50% 50%;
  border: 1px solid blueviolet;
}
.defineSpan {
  font-size: 17px;
  width: 500px;
  height: 50px;
}
#timeline {
  cursor: pointer;
  color: rgb(28, 191, 202);
  font-size: 18px;
}
.disabled {
  background: #ffffff00 !important;
}
.workOrderDiv {
  text-align: center;
  height: 550px;
}
/* ul,li {
    margin: 0;
    padding: 0;
} */

ul {
    width: 99%;
}
.js {
  text-align: center;
  color: #909399;
  font-weight: 700;
}

li {
    list-style: none;
    color: #222527;
    font-size: 18px;
    /* margin: 48px 0; */
    position: relative;
}

li::before,li::after {
    content: "";
    display: block;
    height: 16px;
    width: 100%;
    background-color: #1f4a59;
    position: absolute;
    bottom: -28px;
    border-radius: 6px;
}

li::before {
    box-shadow: 0 0 6px rgba(75, 207, 250, 0.2);
}

li::after {
    background-image: linear-gradient(90deg,
            #0fbcf9,
            #34e7e4);
}

li::after {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
}

.js::after {
    animation-name: js;
}

@keyframes js {
    from {
        width: 0;
    }

    to {
        width: var(--process);
    }
}
</style>
